import { ModelContainer, GlobalErrorMessage, connected } from 'shared'
import { Model } from 'api'
import { PolymorphicModal } from '.'
import { useEffect } from 'react'

const TopLevelPage = ({ base, className, modelId, children, fullWidth, ModalClass = PolymorphicModal }) => {
  // State

  // Hooks
  useEffect(() => {
    App.state.setObject({ base: base })
  }, [])

  // Custom Methods
  const renderModal = () => {
    let activeModalType = application.state.getObject('activeModalType')
    if (activeModalType) return <ModalClass model={activeModalType} returnUrl={base} />

    if (modelId == null) return null
    if (modelId == 'chat') return <ModalClass model='chat' returnUrl={base} />
    if (modelId == 'guest-signup') return <ModalClass model='guest-signup' returnUrl={base} />

    let pureModelId = Model.extractPureModelId(modelId)
    let subroute = Model.extractSubroute(modelId)

    return <ModelContainer modelId={pureModelId}>
      { model => <ModalClass model={model} returnUrl={base} subroute={subroute} /> }
    </ModelContainer>
  }

  if (User.current && User.current.mustChangePassword)
    App.go('change-password')

  return (
    <div className={classNames(className, { container: !fullWidth })}>
      {children}
      {renderModal()}
      {App.state.error && <GlobalErrorMessage />}
    </div>
  )
}

export default TopLevelPage
